module.exports = __webpack_public_path__ + "static/aji-068e8dfdb7115d4e33b5736ad8032c3c.png";